
ADILF.define('css/css!streamhub-hot-collections/styles/style',[],function(){});